import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconAppCloudDvrProps } from './IconAppCloudDvr.types'
import * as Styled from './styles/IconAppCloudDvr.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAppCloudDvr: FC<IconAppCloudDvrProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAppCloudDvrProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconAppCloudDvrProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M14.793 18.5s2.805.11 3.898-.375a4.78 4.78 0 0 0 2.786-3.875c.164-1.637-.582-3.434-1.993-4.3-.699-.434-1.52-.61-2.34-.68a9.858 9.858 0 0 0-1.398.062 5.463 5.463 0 0 0-4.738-3.82 5.312 5.312 0 0 0-4.465 1.89A5.502 5.502 0 0 0 5.43 9.586c-.055.21-.16.805-.16.805a4.188 4.188 0 0 0-1.485.843C2.473 12.41 2.152 14.418 2.887 16c.668 1.434 2.101 2.5 3.695 2.5Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M7.5 12.316v3.414a.3.3 0 0 0 .293.301.286.286 0 0 0 .191-.058l.043-.028 2.274-1.625.066-.05a.259.259 0 0 0 .125-.172.27.27 0 0 0-.035-.211l-.004-.012a.289.289 0 0 0-.09-.078l-.062-.047-2.266-1.625a.327.327 0 0 0-.348-.07.308.308 0 0 0-.187.285v.023m7.012-.332v4m2-4v4'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconAppCloudDvr
